import { useLocation } from 'react-router-dom';

/**
 * Given a subpath without leading or trailing slashes, it returns true if the current pathname includes the subpath.
 * @example
 * Given a URL `/company/<id>/dma/overview/scale?scenarioId=<scenarioId>` and a subpath of `dma`
 * `true` is returned.
 *
 * @param subpath - The subpath to check for
 * @returns True if the current pathname includes the subpath, false otherwise
 */
export function useHasSubpath(subpath: string) {
  const location = useLocation();
  return location.pathname.split('/').includes(subpath);
}
